'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Product model */


/** Exported types */
var Product = (0, _immutable.Record)({
    title: '',
    url: '',
    target: '_self',
    backgroundColor: '',
    icon: ''
});

/**
 * Converts a single product to a data model
 * @param {PlatformType} platform The platform to get the products for
 * @returns {function(ProductListType, SquizProductType)} A function which adds the passed product to the accumulator
 * list
 */

var productToDataModel = function productToDataModel(platform) {
    return function (bag, product) {
        var _product$link$platfor = product.link[platform],
            url = _product$link$platfor.url,
            enabled = _product$link$platfor.enabled;


        if (enabled) {
            return bag.push(new Product((0, _extends3.default)({
                url: url
            }, product)));
        }

        return bag;
    };
};

/**
 * Wrapper function to get platform parameter in scope
 * @param {Array<SquizProductType>} products An array of products as returnd by Squiz
 * @param {PlatformType} platform The platform that was requested
 * @returns {ProductListType} An immutable list of Product Records
 */
var transformProductData = function transformProductData(products) {
    var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mobile';

    if (products.data) {
        return products.data.reduce(productToDataModel(platform), (0, _immutable.List)());
    } else if (products.error) {
        var _products$error = products.error,
            status = _products$error.status,
            _title = _products$error.title,
            _products$error$detai = _products$error.detail,
            detail = _products$error$detai === undefined ? '' : _products$error$detai,
            source = _products$error.source;

        throw new Error('[' + status + '] ' + _title + ', ' + detail + '. Source: ' + source);
    }
    return (0, _immutable.List)();
};

exports.default = transformProductData;
//# sourceMappingURL=model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/product-nav/model.js
// module id = 256
// module chunks = 0